import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/kangaroo1.png";
import projImg2 from "../assets/img/kangaroo2.png";
import projImg3 from "../assets/img/kangaroo3.png";
import projImg4 from "../assets/img/aminute1.png";
import projImg5 from "../assets/img/aminute2.png";
import projImg6 from "../assets/img/aminute3.png";
// App ui image////////////
import app1 from "../assets/img/BestNepal/boomracing.png";
import app2 from "../assets/img/BestNepal/scaletra.png";
import app3 from "../assets/img/BestNepal/atees.png";
import app4 from "../assets/img/BestNepal/finye.png";
import app5 from "../assets/img/BestNepal/lumle.png";
import app6 from "../assets/img/BestNepal/eventpapa.png";
// startup ui image////////////
import start1 from "../assets/img/startups/image 4.png";
import start2 from "../assets/img/startups/image 3.png";
import start3 from "../assets/img/startups/image 2.png";
import start4 from "../assets/img/appui/snapgreet1.png";
import start5 from "../assets/img/Blissful_Bash.jpg";
import start6 from "../assets/img/Joyful_Jubilee.jpg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const startup = [
    {
      title: "Invenzo (Inventory Management System)",
      description: "Dashboard Design & Development",
      imgUrl: start1,
      url: "https://missin-dependent.com/",
      slug: "invenzo",
    },
    {
      title: "Business Operation on Invenzo",
      description: "Product details and management ",
      imgUrl: start2,
      url: "https://missin-dependent.com/",
      slug: "invenzo",
    },
    {
      title: "POS System",
      description: "Sales management system POS",
      imgUrl: start3,
      url: "https://missin-dependent.com/",
      slug: "invenzo",
    },
    {
      title: "Concept of SnapGreet",
      description: "Design & Development",
      imgUrl: start4,
      url: "https://snap-greet.com",
      slug: "snapgreet",
    },
    {
      title: "New Way of Greeting",
      description: "Design & Development",
      imgUrl: start5,
      url: "https://snap-greet.com",
      slug: "snapgreet",
    },
    {
      title: "Birthday Template",
      description: "Design & Development",
      imgUrl: start6,
      url: "https://snap-greet.com",
      slug: "snapgreet",
    },
  ];
  const projects = [
    {
      title: "Kindergarten School",
      description: "Design & Development",
      imgUrl: projImg1,
      url: "https://kangarookids.edu.np/",
      slug: "kangaroo-kids",
    },
    {
      title: "Kids Content",
      description: "Design & Development",
      imgUrl: projImg2,
      url: "https://kangarookids.edu.np/",
      slug: "kangaroo-kids",
    },
    {
      title: "Kids Friendly Design",
      description: "Design & Development",
      imgUrl: projImg3,
      url: "https://kangarookids.edu.np/",
      slug: "kangaroo-kids",
    },
    {
      title: "Sports Bar Design",
      description: "Design & Development",
      imgUrl: projImg4,
      url: "https://snookeraminute.netlify.app/",
      slug: "snooker-bar",
    },
    {
      title: "About Bar and club",
      description: "Design & Development",
      imgUrl: projImg5,
      url: "https://snookeraminute.netlify.app/",
      slug: "snooker-bar",
    },
    {
      title: "Snooker Bar Gallery",
      description: "Design & Development",
      imgUrl: projImg6,
      url: "https://snookeraminute.netlify.app/",
      slug: "snooker-bar",
    },
  ];
  const apps = [
    {
      title: "Boomracing RC",
      description: "Refactoring Design and Development",
      imgUrl: app1,
      url: "https://www.boomracing.com/",
      slug: "boomracing",
    },
    {
      title: "Scaletra",
      description: "Design & Development",
      imgUrl: app2,
      url: "https://scaletra.com/",
      slug: "scaletra",
    },
    {
      title: "AsiaTees",
      description: "Refactoring Design and Development",
      imgUrl: app3,
      url: "https://www.asiatees.com/",
      slug: "asiatees",
    },
    {
      title: "FINYE ORG",
      description: "Refactoring Design and Development",
      imgUrl: app4,
      url: "https://finye.org/",
      slug: "finye",
    },
    {
      title: "Lumle Holidays",
      description: "Refactoring Design and development of Wordpress website",
      imgUrl: app5,
      url: "https://www.lumle.com/",
      slug: "lumle",
    },
    {
      title: "Event Papa",
      description: "UI/UX and Development",
      imgUrl: app6,
      url: "https://www.figma.com/design/FtI9exW19Yb9frJyXYU2kl/Event-Papa-Redesigning?node-id=128-609&t=bycf7LYD5bFqK40c-1",
      slug: "eventpapa",
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div>
                  <div className="container">
                    <h2>Projects</h2>
                    <p className="font-xs">
                      Showcasing innovative projects with cutting-edge design
                      and development. Discover the work that defines my
                      expertise.
                    </p>
                    <Tab.Container id="projects-tabs" defaultActiveKey="second">
                      <Nav
                        variant="pills"
                        className="nav-pills mb-5 justify-content-center align-items-center"
                        id="pills-tab"
                      >
                        <Nav.Item>
                          <Nav.Link eventKey="first">Startups</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">Work Experience</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="third">Social Plans </Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content id="slideInUp">
                        <Tab.Pane eventKey="first">
                          <Row>
                            {startup.map((project, index) => {
                              return <ProjectCard key={index} {...project} />;
                            })}
                          </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                          <Row>
                            {apps.map((project, index) => {
                              return <ProjectCard key={index} {...project} />;
                            })}
                          </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="third">
                          <Row>
                            {projects.map((project, index) => {
                              return <ProjectCard key={index} {...project} />;
                            })}
                          </Row>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      {/* <img className="background-image-right" src={colorSharp2}></img> */}
    </section>
  );
};
